export enum ModalRoleEnum {
  Dialog = 'dialog',
  AlertDialog = 'alertdialog',
}
